<template>
  <el-card v-loading="loadFlag">
    <el-row>
      <el-col :span="24" style="margin-bottom: 20px; margin-top: 10px; display: flex">
        <el-radio-group v-model="deptName" @input="radioInputChange">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button label="上海打样间">上海</el-radio-button>
          <el-radio-button label="扬州打样间">扬州</el-radio-button>
        </el-radio-group>
        <div class="diagramTitle">
          <span class="vg_ml_8" style="font-size: 20px; margin-right: 10px">接收时间:</span>
          <div class="dateSelect">
            <el-date-picker v-model="daytime[0]" type="date"> </el-date-picker>
            <span style="font-size: 20px">至</span>
            <el-date-picker v-model="daytime[1]" type="date"> </el-date-picker>
          </div>
          <el-button class="buttonText" round size="mini" @click="timeScope(1)">近一月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(3)">近三月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(6)">近六月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(0)">全部</el-button>
          <el-button class="buttonText" round size="mini" type="primary" @click="getTableData">查询</el-button>
          <el-button class="buttonText" round size="mini" type="info" @click="refresh">刷新</el-button>
          <el-button class="buttonText" round size="mini" type="success" @click="exportToExcel">导出Excel</el-button>
        </div>
      </el-col>
      <el-col :span="24">
        <el-row :gutter="100">
          <el-col :span="12">
            <el-card>
              <VueEcharts :option="option1" style="height: 300px"></VueEcharts>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <VueEcharts :option="option2" style="height: 300px"></VueEcharts>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <search-table
          ref="searchTable"
          :columnMove="false"
          :columns="tableProperties"
          :data="tableData"
          :need-pagination="true"
          :page-size="10"
          :show-summary="true"
          :summaryTotalArray="summaryTotalArray"
          :tableRowKey="'id'"
          :total-page="totalPage"
          @getTableData="getTableData"
        />
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import { dataStaticsAPI } from '@api/modules/stat';
import { postNoCatch } from '@api/request';
import { cloneDeep } from 'lodash';

export default {
  name: 'StatisticsOnTheProportionOfProofing',
  components: { SearchTable },
  data() {
    return {
      option1: {
        title: {
          text: '各委托部门款数占比',
          subtext: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: [],
            label: {
              formatter: params => params.data.label || params.name
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        label: {
          formatter: function (data) {
            return `${data.label} ${data.value} (${data.percent.toFixed(1)}%)`;
          }
        }
      },
      option2: {
        title: {
          text: '各产品类型款数占比',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: [],
            label: {
              formatter: params => params.data.label || params.name
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        label: {
          formatter: function (data) {
            return `${data.label} ${data.value} (${data.percent.toFixed(1)}%)`;
          }
        }
      },
      tableData: [],
      tableProperties: [
        { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
        { label: '委托部门', prop: 'dept_name', otherProp: 'deptNameList', multiple: true, itemType: 'select', options: [], input: true },
        { label: '委托人', prop: 'stff_name', otherProp: 'StffNameList', multiple: true, itemType: 'select', options: [], input: true },
        { label: '样品类型', prop: 'smpl_type', otherProp: 'smplTypeList', multiple: true, itemType: 'select', options: [], input: true },
        { label: '委托类型', prop: 'smpl_quot', otherProp: 'smplQuotList', multiple: true, itemType: 'select', options: [], input: true },
        {
          label: '产品类型',
          prop: 'product_type',
          otherProp: 'productTypeList',
          multiple: true,
          itemType: 'select',
          options: [],
          input: true
        },
        { label: '样品款数', prop: 'numberOfSampleModels', itemType: 'input', input: false },
        { label: '样品数量', prop: 'numberOfSamples', itemType: 'input', input: false }
      ],
      daytime: [],
      loadFlag: false,
      summaryTotalArray: [],
      totalPage: 0,
      deptName: null
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    exportToExcel(val) {
      postNoCatch(dataStaticsAPI.excelStatiTheProporSampl, this.getSearchForm()).then(({ data }) => {
        this.helper.downloadItemExcel(data.url, data.fileName);
      });
    },
    refresh() {
      this.daytime = [];
      this.$refs.searchTable.resetFields();
      this.getTableData();
    },
    getSearchForm() {
      let searchForm = cloneDeep(this.$refs.searchTable.searchForm);
      const [startTime, endTime] = cloneDeep(this.daytime || []);
      // 确保时间戳被正确赋值且进行单位转换（如果需要）
      searchForm.start_time = startTime ? Math.floor(startTime / 1000) : null;
      searchForm.end_time = endTime ? Math.floor(endTime / 1000) : null;
      return searchForm;
    },
    getTableData() {
      this.loadFlag = true;
      postNoCatch(dataStaticsAPI.getStatiTheProporSampl, this.getSearchForm()).then(({ data }) => {
        this.tableData = data.list;
        this.totalPage = data.total;
        this.tableProperties.forEach(item => {
          if (item.label === '样品类型') item.options = data.smplTypeList;
          if (item.label === '委托人') item.options = data.StffNameList;
          if (item.label === '委托类型') item.options = data.smplQuotList;
          if (item.label === '产品类型') item.options = data.productTypeList;
          if (item.label === '委托部门') item.options = data.deptNameList;
        });
        data.proportionOfDepartmentalFunds.forEach(item => (item.name = item.label));
        data.proportionOfProductTypes.forEach(item => (item.name = item.label));
        this.option1.series[0].data = data.proportionOfDepartmentalFunds;
        this.option2.series[0].data = data.proportionOfProductTypes;
        let temp = new Array(8);
        temp[5] = '总计';
        temp[6] = data.mapSum.numberOfSampleModels;
        temp[7] = data.mapSum.numberOfSamples;
        this.summaryTotalArray = temp;
        this.loadFlag = false;
        this.$nextTick(() => {
          this.$refs.searchTable?.$refs.multiTable.doLayout();
        });
      });
    },
    timeScope(val) {
      this.daytime = val === 0 ? [] : [Math.floor(new Date().setMonth(new Date().getMonth() - val)), Math.floor(Date.now())];
      this.getTableData();
    },
    radioInputChange(val) {
      this.$refs.searchTable.searchForm.proofing_dept_name = this.deptName;
      this.getTableData();
    }
  }
};
</script>

<style scoped>
.diagramTitle {
  display: flex;
  align-items: center;
}
.buttonText {
  font-size: 18px;
}
.dateSelect {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
</style>
